import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import ReactDOM from 'react-dom';

export default class ActionSection extends React.Component {
  static propTypes = {
    disableDockOnScroll: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string
  };

  constructor() {
    super();

    this.state = { docked: false, height: 0 };

    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    $(window).scroll(this.onScroll);
  }

  componentWillReceiveProps() {
    this.onScroll();
  }

  componentWillUnmount() {
    $(window).off('scroll', this.onScroll);
  }

  onScroll() {
    const el = $(ReactDOM.findDOMNode(this));
    const elementTop = el.offset().top;
    const scroll = $(window).scrollTop();
    const wrapperHeight = el.find('.action-wrapper').outerHeight();
    const elHeight = el.find('.action-wrapper .actions').outerHeight();
    const height = wrapperHeight < elHeight ? wrapperHeight : elHeight;
    const docked = scroll > elementTop;

    if (this.state.docked !== docked || this.state.height !== height) this.setState({ docked, height });
  }

  render() {
    const { docked, height } = this.state;
    const { disableDockOnScroll, children, className, ...props } = this.props;

    return (
      <div className="actions-container" style={{ minHeight: height }}>
        <div className={classNames('action-wrapper', { docked: docked && !disableDockOnScroll })}>
          <div {...props} className={classNames(className, 'actions')}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}
